import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../data.service';
import { AuthenticationResult } from '@azure/msal-browser';
import { MsalService } from '@azure/msal-angular';
import { urls } from '../urls';
import { GoogleAnalyticsServiceService } from '../google-analytics-service.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  invalid: boolean;
  searchStr: string;

  constructor(private route: ActivatedRoute, private router: Router, private service: DataService, private _msalService: MsalService, private googleAnalytics: GoogleAnalyticsServiceService, private dataService: DataService) { }

  ngOnInit(): void {
    if (this.route.snapshot.queryParams['ref']) {
      const ref = this.route.snapshot.queryParams['ref'];
      // const ref = atob(this.route.snapshot.queryParams['ref']);
      this.searchStr = this.route.snapshot.queryParams['searchStr'];
      if (ref) {
        this.authenticateUserToken(ref, true);
      }
    }
  }
  microsoftSignIn() {

    this._msalService.loginPopup().subscribe((userData: AuthenticationResult) => {

      if (userData['accessToken']) {
        //this.userLogin(userData.idTokenClaims['preferred_username'].toLowerCase());
        this.userLogin(userData.idTokenClaims['preferred_username'].toLowerCase(), userData['accessToken']);
      }
    });
  }

  userLogin(email, accessToken,autoLogin = false) {
    // send the parameters if login successfull rediect to page else remain on this page

    const url = urls.catalogUserLogin;
     const body = {
        userEmail: email,
        jwtToken: accessToken,
        domainType: 'ECS'
    };


 this.service.callRestful(
        'POST',
        url,
        body,
        null,
        null,
        null
    ).subscribe(
        data => this.processLoginResult(data,autoLogin),
        error => {
            console.error('Login API error:', error);

            this.invalid = true;
            this.service.showMessage(
                'error',
                'Unable to login. Please try again.'
            );
            this.service.offSpinner();
        }
    );
  }

  processLoginResult(data, autoLogin) {

    this.googleAnalytics.trackEvent('button_click', 'User Interaction', 'Sign Up Button');


    if (data.status) {
      this.invalid = false;
      this.service.createSession('1', data.data.userName, data.data.token);
      this.service.showMessage('success', 'Login successfully');
      this.service.offSpinner();
      if (autoLogin) {
        console.log("Auto login successful, redirecting to category discovery");
        this.dataService.setSelectedCountryCode("356");
        this.dataService.setSelectedCountryName("India");
        if (this.searchStr) {
          this.router.navigateByUrl('/product-discovery?searchStr=' + this.searchStr);
        } else {
          this.router.navigateByUrl('/category-discovery');
        }
      } else {
        this.router.navigateByUrl('/country');
      }

    } else {
      console.error("Login failed", data);
      this.invalid = true;
      this.service.showMessage('error', data.message);
      this.service.offSpinner();
    }

  }

  // getUserEmailFromToken(accessToken: string) {
  //   // Call Microsoft Graph API to get user details
  //   const headers = new Headers({
  //     'Authorization': `Bearer ${accessToken}`,
  //   });

  //   fetch('http://localhost:8082/catalog/user/verify', { method: 'GET', headers })
  //     .then(response => response.json())
  //     .then(data => {
  //       const email = data.mail || data.userPrincipalName;
  //       this.userLogin(email, true);
  //     })
  //     .catch(error => {
  //       console.error("Error fetching user details", error);
  //     });
  // }

  getUserEmailFromToken(accessToken: string) {
    const headers = new Headers({
      'Authorization': `Bearer ${accessToken}`,
    });

    const url = urls.prod_supp + urls.verifyToken;


    fetch(url, { method: 'GET', headers })
      .then(response => response.json())
      .then(data => {
        if (data.status && data.data && data.data.email) {
          const email = data.data.email;  // extract from response structure
          this.userLogin(email, true);
        } else {
          console.error("Invalid token or missing email in response", data);
        }
      })
      .catch(error => {
        console.error("Error verifying token", error);
      });
  }

authenticateUserToken(accessToken: string, autoLogin: boolean) {

  const url =  urls.verifyToken;

  const headers = new Headers({
    'Content-Type': 'application/json'
  });

  const body = {
    token: accessToken,
    requestBy: 'Eoc-cis'
  };

  fetch(url, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(body)
  })
    .then(response => response.json())
    .then(data => {

      console.log('Authentication response:', data);

      if (data.statusCode === 200 && data.status === 'AUTHORIZED') {

        this.invalid = false;

        // Use the token passed to this method
        this.service.createSession('1', data.data.username, accessToken);

        this.service.showMessage('success', 'Login successfully');

        this.service.offSpinner();
        if (autoLogin) {

          console.log(
            'Auto login successful, redirecting to category discovery'
          );

          this.dataService.setSelectedCountryCode('356');
          this.dataService.setSelectedCountryName('India');

          if (this.searchStr) {

            this.router.navigateByUrl(
              '/product-discovery?searchStr=' + this.searchStr
            );

          } else {

            this.router.navigateByUrl('/category-discovery');

          }

        } else {

          this.router.navigateByUrl('/country');
        }

      } else {

        this.invalid = true;
        this.service.offSpinner();

        console.error('Token authentication failed:', data);

      }
    })
    .catch(error => {

      this.invalid = true;
      this.service.offSpinner();

      console.error('Error authenticating token:', error);

    });
}


}
